import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FeedReadPositionField extends BaseOption {
  static userInterfaceComponent = {
    label: "Last read",
    component: inspectorTools.SIMPLE_PICKER,
    descriptionMessage: "The reference that holds the last row this viewer read.",
    props: {
      options: [],
    },
  };

  static defaultValue = "";
}
